export default __webpack_public_path__ + "static/media/our-services-home-care-live-in-care.736361e9.jpg";